module.exports = __webpack_public_path__ + "static/media/1-1.b12c33a0.mp3";